import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';  
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroupDirective, NgForm } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CloseScrollStrategy } from '@angular/cdk/overlay';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-prereg',
  templateUrl: './prereg.component.html',
  styleUrls: ['./prereg.component.css']
})
export class PreregComponent {
  submitted = false;
  hide = true;
  isLoading: boolean;
  showPassword: boolean = false;
  sources = [
    { value: 'Social Media', viewValue: 'Social Media' },
    { value: 'Campus Ambassador', viewValue: 'Campus Ambassador' },
    { value: 'National Enterpreneurship Challenge participant', viewValue: 'National Enterpreneurship Challenge participant' },
    { value: 'Previous year participant', viewValue: 'Previous year participant' },
    { value: 'Online articles/ Newspaper', viewValue: 'Online articles/ Newspaper' },
    { value: 'Others', viewValue: 'Others' },
  ];
  gender = [
    { value: 'Male', viewValue: 'Male' },
    { value: 'Female', viewValue: 'Female' },
    { value: 'Others', viewValue: 'Others' },
    { value: 'No', viewValue: 'Prefer not to say' },
  ];  
  status = [
    { value: 'iit', viewValue: 'IIT student/staff/alum' },
    { value: 'w', viewValue: 'Working' },
    { value: 'othStu', viewValue: 'Other Student' },
    { value: 'oth', viewValue: 'Other' },
  ];
  country = [
    { value: 'ind', viewValue: 'India' },
    { value: 'bah', viewValue: 'Bahrain' },
    { value: 'kuw', viewValue: 'Kuwait' },
    { value: 'oman', viewValue: 'Oman' },
    { value: 'quatar', viewValue: 'Qatar' },
    { value: 'saudi', viewValue: 'Saudi Arabia' },
    { value: 'uae', viewValue: 'The United Arab Emirates' },
    { value: 'other', viewValue: 'Other' },
  ];
  states = [
    { value: 'Other', viewValue: 'Other'},
    { value: 'Andhra Pradesh', viewValue: 'Andhra Pradesh' },
    { value: 'Arunachal Pradesh', viewValue: 'Arunachal Pradesh' },
    { value: 'Assam', viewValue: 'Assam' },
    { value: 'Bihar', viewValue: 'Bihar' },
    { value: 'Chhattisgarh', viewValue: 'Chhattisgarh' },
    { value: 'Goa', viewValue: 'Goa' },
    { value: 'Gujarat', viewValue: 'Gujarat' },
    { value: 'Haryana', viewValue: 'Haryana' },
    { value: 'Himachal Pradesh', viewValue: 'Himachal Pradesh' },
    { value: 'Jharkhand', viewValue: 'Jharkhand' },
    { value: 'Karnataka', viewValue: 'Karnataka' },
    { value: 'Kerala', viewValue: 'Kerala' },
    { value: 'Madhya Pradesh', viewValue: 'Madhya Pradesh' },
    { value: 'Maharashtra', viewValue: 'Maharashtra' },
    { value: 'Manipur', viewValue: 'Manipur' },
    { value: 'Meghalaya', viewValue: 'Meghalaya' },
    { value: 'Mizoram', viewValue: 'Mizoram' },
    { value: 'Nagaland', viewValue: 'Nagaland' },
    { value: 'Odisha', viewValue: 'Odisha' },
    { value: 'Punjab', viewValue: 'Punjab' },
    { value: 'Rajasthan', viewValue: 'Rajasthan' },
    { value: 'Sikkim', viewValue: 'Sikkim' },
    { value: 'Tamil Nadu', viewValue: 'Tamil Nadu' },
    { value: 'Telangana', viewValue: 'Telangana' },
    { value: 'Tripura', viewValue: 'Tripura' },
    { value: 'Uttarakhand', viewValue: 'Uttarakhand' },
    { value: 'Uttar Pradesh', viewValue: 'Uttar Pradesh' },
    { value: 'West Bengal', viewValue: 'West Bengal' },
    { value: 'Andaman and Nicobar Islands (UT)', viewValue: 'Andaman and Nicobar Islands (UT)' },
    { value: 'Chandigarh (UT)', viewValue: 'Chandigarh (UT)' },
    { value: 'Dadra and Nagar Haveli (UT)', viewValue: 'Dadra and Nagar Haveli (UT)' },
    { value: 'Daman and Diu (UT)', viewValue: 'Daman and Diu (UT)' },
    { value: 'Delhi (NCT)', viewValue: 'Delhi (NCT)' },
    { value: 'Jammu and Kashmir (UT)', viewValue: 'Jammu and Kashmir (UT)' },
    { value: 'Ladakh (UT)', viewValue: 'Ladakh (UT)' },
    { value: 'Lakshadweep (UT)', viewValue: 'Lakshadweep (UT)' },
    { value: 'Puducherry (UT)', viewValue: 'Puducherry (UT)' },
  ];
  bool = [
    { value: 'Yes', viewValue: 'Yes' },
    { value: 'No', viewValue: 'No' },
  ];
  title = 'newMat';
  firstFormGroup: FormGroup;
  cols = 2;
  constructor(private _formBuilder: FormBuilder,private router: Router, private http: HttpClient) {}
  displayStyles = "none";
  ngOnInit(): void {
    if( window.screen.width<768){
      this.cols =1;
    }  

    this.firstFormGroup = this._formBuilder.group({
      name: ['', Validators.required],
      email:['', Validators.compose([Validators.required, Validators.email])],
      gender: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      countrycode: ['+91', Validators.required],
      contact: ['', Validators.compose([Validators.required, Validators.min(10)])],
      status: ['', Validators.required],
      password: ['', [Validators.required, Validators.min(3)]],
      source: ['', Validators.required],
      referral: [''],
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  submit(){
    console.log('submitted')
  }
}
